import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

const Select = (props) => {
  const { options, value, transparent, className, name, onChange } = props

  const selectedOption = options.find((option) => option.value === value) || {
    label: '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0',
  }

  return (
    <div className={`select ${transparent ? 'transparent' : ''} ${className}`}>
      <label htmlFor={name}>{selectedOption.label}</label>
      <span className="select-chevron" />
      <select
        className="visual-select-performed"
        name={name}
        value={value}
        onChange={onChange}
      >
        {options.map((option, index) => (
          // eslint-disable-next-line
          <option value={option.value} key={`${name}-${index}`}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

Select.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  transparent: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
}

Select.defaultProps = {
  name: 'select',
  className: '',
  value: '',
  transparent: false,
  options: [],
}

export default Select
